import { SingleChoiceConfirmModalProps } from '@monorepo/shared/componentsV2/modals/ConfirmModal';
import { createContext } from 'react';

type ConfirmModalOptsBase = Pick<
  SingleChoiceConfirmModalProps,
  | 'cancelButtonText'
  | 'confirmButtonText'
  | 'danger'
  | 'description'
  | 'showCloseButton'
  | 'title'
>;

type ConfirmModalOptsWithAsyncProcessing = ConfirmModalOptsBase &
  Pick<
    SingleChoiceConfirmModalProps,
    'onConfirmAsync' | 'afterConfirmButtonText'
  >;

type ConfirmModalOptsNoAsyncProcessing = ConfirmModalOptsBase & {
  onConfirmAsync?: never;
  afterConfirmButtonText?: never;
};

export type ConfirmModalOpts =
  | ConfirmModalOptsWithAsyncProcessing
  | ConfirmModalOptsNoAsyncProcessing;

export interface ModalContextValue {
  confirm: (opts: ConfirmModalOpts) => Promise<boolean>;
}

const defaultValue: ModalContextValue = {
  confirm: () => Promise.resolve(false),
};

export const ModalContext = createContext(defaultValue);
